import { useState, useEffect } from 'react';
import { isHalfByBridgeAsync } from '@/common/device-info';
import yoda from '@kibt/bridge';
import { getPageProps } from '@kibt/krn-utils';
import { useIsFocused } from './useIsFocused';
export function useWebviewType() {
    const [webviewType, setWebviewType] = useState<'fullScreen' | 'halfScreen'>('fullScreen');
    const isFocused = useIsFocused();
    // 半全屏切换这个值会实时变换,
    useEffect(() => {
        if (getPageProps().isHalf !== '1') return;
        isHalfByBridgeAsync().then((res) => {
            setWebviewType(res ? 'halfScreen' : 'fullScreen');
        });
    }, []);

    // iOS 11 切换半全屏时 没有触发NavBar重绘，hooks未更新
    // 此处增加事件，手动重新获取并更新顶部高度响应
    const onSlidingStatusChange = () => {
        if (!isFocused) return;

        isHalfByBridgeAsync().then((res) => {
            setWebviewType(res ? 'halfScreen' : 'fullScreen');
        });
    };
    useEffect(() => {
        if (getPageProps().isHalf !== '1') return;
        yoda.event.addEventListener('krn_bottom_sheet_on_sliding_status_change', onSlidingStatusChange, ({ result }) => {
            // addEventListener bridge 本身是否调用成功
            if (result === 1) {
                // 成功
                console.log('addEventListener success');
            } else {
                // 失败
                console.log('addEventListener failed');
            }
        });
    }, [isFocused]);
    return webviewType;
}
